import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';

import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { bimUseActKC2OtherTotalInflationGql } from '../bimWorkOrderOtherActKC2Queries';

const requestId = 'bimUseActKC2OtherTotalInflation';

export const useBimActKC2OtherTotalInflation = (actKC2OtherId: number, onSuccess: () => void) => {
    const dispatch = useDispatch();

    const [bimUseActKC2OtherTotalInflationMakeReset] = useResetStoreData({
        requestId,
    });

    const [, bimUseActKC2OtherTotalInflationStatus, , bimUseActKC2OtherTotalInflationMakeRequest] = useRequest({
        requestId,
        query: bimUseActKC2OtherTotalInflationGql,
        withEffect: false,
        dependenciesUpdater: onSuccess,
    });

    const bimUseActKC2OtherTotalInflationRequest = useCallback(
        (workOrderSeasonId: number) => {
            bimUseActKC2OtherTotalInflationMakeReset(undefined);
            dispatch(bimUseActKC2OtherTotalInflationMakeRequest({ actKC2OtherId, workOrderSeasonId }));
        },
        [actKC2OtherId, bimUseActKC2OtherTotalInflationMakeRequest, bimUseActKC2OtherTotalInflationMakeReset, dispatch],
    );

    useEffect(() => {
        bimUseActKC2OtherTotalInflationMakeReset(undefined);
    }, [bimUseActKC2OtherTotalInflationMakeReset]);

    return {
        bimUseActKC2OtherTotalInflationStatus,
        bimUseActKC2OtherTotalInflationRequest,
    };
};
